import { COMPANY } from "@/data/content";

/**
 * Forward a lead to WhatsApp (+91 8178965407) by opening wa.me with the
 * submitted form data pre-filled. The message lands in Orina's WhatsApp inbox.
 *
 * Falls back gracefully on desktop browsers that block window.open.
 */
export function forwardLeadToWhatsApp({ name, email, phone, company, marketplace, message, source }) {
  const number = COMPANY.whatsapp.replace(/\D/g, "");
  const lines = [
    `🟡 New lead from orinaenterprise.com — ${labelForSource(source)}`,
    "",
    name && `*Name:* ${name}`,
    phone && `*Phone:* ${phone}`,
    email && !email.startsWith("quiz-") && `*Email:* ${email}`,
    company && `*Company / Category:* ${company}`,
    marketplace && `*Marketplace:* ${marketplace}`,
    message && `*Message:*\n${message}`,
  ].filter(Boolean);

  const text = encodeURIComponent(lines.join("\n"));
  const url = `https://wa.me/${number}?text=${text}`;

  // Try opening in a new tab; fall back to same-window if blocked.
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) {
    window.location.href = url;
  }
  return url;
}

function labelForSource(source) {
  const map = {
    contact_form: "Contact form",
    audit: "Free Audit request",
    expert: "Talk to expert",
    start: "Start selling",
    onboard: "Marketplace onboarding",
    quiz: "Marketplace Readiness Quiz",
    chatbot: "Chatbot lead",
    google_extractor: "Google Extractor purchase",
    extractor: "Extractor enquiry",
    "extractor-demo": "Extractor demo request",
    crm: "CRM Solutions enquiry",
    manpower: "Manpower Solutions enquiry",
    devproject: "Web/App project",
  };
  return map[source] || "Lead";
}
